'use strict';
import _, { get, isNil, merge, reduce, set, forEach, find } from 'lodash';
import moment from 'moment';
import React, { PropTypes } from 'react';
import { validateFormField } from '../../../../../../modelValidator';
import { convertEmployeeToMenuItems } from '../../../../../../redux/helpers/staticData';
import { mapFormFields, fieldsHasErrors } from '../../../../../../lib/form';
import * as contactApi from '../../../../../../redux/actionCreators/async/contacts';
import * as contactStore from '../../../../../../redux/actionCreators/sync/contacts';
import * as ui from '../../../../../../redux/actionCreators/sync/ui';
import TextField from '../../../../../../common/components/c_TextField';
import MaskedTextField from '../../../../../../common/components/c_MaskedTextField';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import Button from '../../../../../../common/components/Button';
import ModalX from '../../../../../../common/svgs/ModalX';

const formFields = {
  user: {
    required : ['firstName', 'lastName', 'email'],
    optional : ['dateModified', 'phoneNumber1', 'phoneType1', 'phoneNumber2', 'phoneType2', 'address', 'address2', 'city', 'state', 'zip', 'timezone', 'phoneExtension1', 'phoneExtension2']
  },
  profile: {
    required : ['clientAdvisorId'],
    optional : ['dateModified', 'dateCreated']
  },
  company: {
    required : ['name'],
    optional : []
  }
};

function EditContactDetailsForm(props) {
  const {
    updateField,
    onClose,
    saveContact,
    contact,
    clientAdvisors,
    timezoneList,
    stateList,
    contactPhoneTypes,
    isDirty,
    tasks,
    hasEditRights,
  } = props || {};

  function handleChange(model, prop) {
    return (event, value) => updateField(event, model, prop, value);
  }

  function handleSave(event) {
    (saveContact) && saveContact(event);
  }

  const sanitize = (val) => val || '';
  const lastUpdated = [get(contact, 'user.dateModified.defaultValue'),
                          get(contact, 'profile.dateModified.defaultValue'),
                          get(contact, 'user.dateCreated.defaultValue'),
                          get(contact, 'profile.dateCreated.defaultValue')]
                        .filter(d => !!d)
                        .sort((d1, d2) => moment.utc(d2).diff(moment.utc(d1)))
                        .shift();


  const followUpTask = _(tasks)
                            .filter(task => task.taskFollowUpDate && (new Date(task.taskFollowUpDate) - Date.now() > 0))
                            .sortBy(task => new Date(task.taskFollowUpDate))
                            .head();

  const mainPhone = find(contactPhoneTypes, {name: 'Main'});
  const mainPhoneId = get(mainPhone, 'id');

  return (
    <div className='contact-worksheet-edit-details topmodal'>
      <ModalX onClick={onClose}/>
      <div className='topmodal-container'>
      <div className='grid'>
        <div className='row'>
            <div className='col grow-3'>
                <div className='row'>
                    <div className='col'>
                      <TextField
                        defaultValue={get(contact, 'user.firstName.defaultValue')}
                        floatingLabelText={"First Name"}
                        floatingLabelFixed
                        isDirty={isDirty}
                        errorText={get(contact, 'user.firstName.errors[0]')}
                        onBlur={handleChange('user', 'firstName')}
                        data-id={'firstName'}
                      />
                    </div>
                    <div className='col'>
                      <TextField
                        defaultValue={get(contact, 'user.lastName.defaultValue')}
                        floatingLabelText={"Last Name"}
                        floatingLabelFixed
                        errorText={get(contact, 'user.lastName.errors[0]')}
                        onBlur={handleChange('user', 'lastName')}
                        data-id={'lastName'}
                      />
                    </div>
                </div>
            </div>
            <div className='col'></div>
        </div>
        <div className='row'>
            <div className='col grow-3'>

               <DropDownMenu
                  defaultValue={get(contact, 'profile.clientAdvisorId.defaultValue')}
                  floatingLabelText={"Client Adviser"}
                  errorText={get(contact, 'profile.clientAdvisorId.errors[0]')}
                  onChange={handleChange('profile', 'clientAdvisorId')}
                  menuItems={convertEmployeeToMenuItems(clientAdvisors)}
                  data-id={'clientAdvisor'}
                />

            </div>
            <div className='col'>
              <TextField
                defaultValue={moment(get(contact, 'profile.dateCreated.defaultValue')).format('L')}
                floatingLabelFixed
                floatingLabelText={"Contacted Date"}
                disabled
                data-id={'dateCreated'}
              />
            </div>
        </div>
        <div className='row'>
            <div className='col grow-3'>
                <TextField
                defaultValue={get(contact, 'company.name.defaultValue')}
                floatingLabelText={"Company"}
                floatingLabelFixed
                isDirty={isDirty}
                errorText={get(contact, 'company.name.errors[0]')}
                onBlur={handleChange('company', 'name')}
                disabled={!hasEditRights}
                data-id={'name'}
              />
            </div>
            <div className='col'>
              <TextField
                defaultValue={moment(lastUpdated).format('L')}
                floatingLabelFixed
                floatingLabelText={"Last Updated"}
                disabled
                data-id={'dateModified'}
              />
            </div>
        </div>
        <div className='row'>
            <div className='col grow-3'>
                <TextField
                  defaultValue={get(contact, 'user.email.defaultValue')}
                  floatingLabelFixed
                  floatingLabelText={"Email"}
                  errorText={get(contact, 'user.email.errors[0]')}
                  onBlur={handleChange('user', 'email')}
                  disabled={!hasEditRights}
                  data-id={'email'}
                />
            </div>
            <div className='col'>
              <TextField
                defaultValue={followUpTask ? moment(followUpTask.taskFollowUpDate).format('L') : sanitize(followUpTask)}
                floatingLabelFixed
                floatingLabelText={"Follow Up"}
                disabled
                data-id={'taskFollowUpDate'}
              />
            </div>
        </div>
        <div className='row'>
            <div className='col grow-3'>

              <div className='row'>
                <div className='col'>
                  <TextField
                    defaultValue={get(contact, 'user.address.defaultValue')}
                    floatingLabelFixed
                    isDirty={isDirty}
                    floatingLabelText={"Address Line 1"}
                    errorText={get(contact, 'user.address.errors[0]')}
                    onBlur={handleChange('user', 'address')}
                    data-id={'address'}
                  />
                </div>
                <div className='col'>
                  <TextField
                    defaultValue={get(contact, 'user.address2.defaultValue')}
                    floatingLabelFixed
                    isDirty={isDirty}
                    floatingLabelText={"Address Line 2"}
                    errorText={get(contact, 'user.address2.errors[0]')}
                    onBlur={handleChange('user', 'address2')}
                    data-id={'address2'}
                  />
                </div>
              </div>

            </div>
            <div className='col'>
              <DropDownMenu
                defaultValue={get(contact, 'user.timezone.defaultValue')}
                floatingLabelText={"Time Zone"}
                errorText={get(contact, 'user.timezone.errors[0]')}
                onChange={handleChange('user', 'timezone')}
                menuItems={timezoneList}
                data-id={'timezone'}
              />
            </div>
        </div>
        <div className='row'>
            <div className='col grow-3'>
                <div className='row'>
                    <div className='col'>
                        <TextField
                            defaultValue={get(contact, 'user.city.defaultValue')}
                            floatingLabelText={"City"}
                            floatingLabelFixed
                            errorText={get(contact, 'user.city.errors[0]')}
                            onBlur={handleChange('user', 'city')}
                            data-id={'city'}
                        />
                    </div>
                    <div className='col'>
                        <DropDownMenu
                          defaultValue={get(contact, 'user.state.defaultValue')}
                          floatingLabelText={"State"}
                          errorText={get(contact, 'user.state.errors[0]')}
                          onChange={handleChange('user', 'state')}
                          menuItems={stateList}
                          data-id={'state'}
                        />
                    </div>
                </div>
            </div>
            <div className='col'>
              <TextField
                defaultValue={get(contact, 'user.zip.defaultValue')}
                floatingLabelText={"Zip Code"}
                floatingLabelFixed
                errorText={get(contact, 'user.zip.errors[0]')}
                onBlur={handleChange('user', 'zip')}
                data-id={'zip'}
                maxLength='5'
              />
            </div>
        </div>
        <div className='row'>
            <div className='col grow-3'>
                <div className='row'>
                    <div className='col'>
                      <MaskedTextField
                        mask='(999) 999-9999'
                        hideMaskChar
                        defaultValue={get(contact, 'user.phoneNumber1.defaultValue')}
                        floatingLabelText={"Phone Number"}
                        floatingLabelFixed
                        isDirty={isDirty}
                        errorText={get(contact, 'user.phoneNumber1.errors[0]')}
                        onBlur={handleChange('user', 'phoneNumber1')}
                        data-id={'phoneNumber1'}
                      />
                    </div>
                    <div className='col'>
                      <DropDownMenu
                        defaultValue={get(contact, 'user.phoneType1.defaultValue')}
                        errorText={get(contact, 'user.phoneType1.errors[0]')}
                        onBlur={handleChange('user', 'phoneType1')}
                        menuItems={contactPhoneTypes}
                        data-id={'phoneType1'}
                      />
                    </div>
                </div>
            </div>
            <div className='col'>
             { get(contact, 'user.phoneType1.value') === mainPhoneId && <TextField
                  defaultValue={get(contact, 'user.phoneExtension1.defaultValue')}
                  floatingLabelText={"Extension"}
                  floatingLabelFixed
                  errorText={get(contact, 'user.phoneExtension1.errors[0]')}
                  onBlur={handleChange('user', 'phoneExtension1')}
                  data-id={'phoneExtension1'}
                /> }
            </div>
        </div>
        <div className='row'>
            <div className='col grow-3'>
                <div className='row'>
                    <div className='col'>
                        <MaskedTextField
                          mask='(999) 999-9999'
                          hideMaskChar={true}
                          defaultValue={get(contact, 'user.phoneNumber2.defaultValue')}
                          floatingLabelText={"Phone Number"}
                          floatingLabelFixed
                          isDirty={isDirty}
                          errorText={get(contact, 'user.phoneNumber2.errors[0]')}
                          onBlur={handleChange('user', 'phoneNumber2')}
                          data-id={'phoneNumber2'}
                        />
                    </div>
                    <div className='col'>
                        <DropDownMenu
                          defaultValue={get(contact, 'user.phoneType2.defaultValue')}
                          errorText={get(contact, 'user.phoneType2.errors[0]')}
                          onBlur={handleChange('user', 'phoneType2')}
                          menuItems={contactPhoneTypes}
                          data-id={'phoneType2'}
                        />
                    </div>
                </div>
            </div>
            <div className='col'>

                { get(contact, 'user.phoneType2.value') === mainPhoneId && <TextField
                    defaultValue={get(contact, 'user.phoneExtension2.defaultValue')}
                    floatingLabelText={"Extension"}
                    floatingLabelFixed
                    errorText={get(contact, 'user.phoneExtension2.errors[0]')}
                    onBlur={handleChange('user', 'phoneExtension2')}
                    data-id={'phoneExtension2'}
                /> }



            </div>
        </div>
    </div>

        <div className='actions'>
            <Button
            className={'button-save'}
            data-id={'Save-Contact'}
            label={'Save'}
            disabled={!isDirty}
            onClick={handleSave}
          />
      </div>
    </div>
  </div>
  );
}

export default class EditContactDetails extends React.Component {
  static propTypes = {
    contact : PropTypes.object.isRequired,
    clientAdvisors : PropTypes.array.isRequired,
    timezoneList : PropTypes.array.isRequired,
    stateList : PropTypes.array.isRequired,
    contactPhoneTypes : PropTypes.array.isRequired,
    dispatch : PropTypes.func.isRequired,
    onClose : PropTypes.func.isRequired,
    currentUser: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);

    const {
      user,
      profile,
      company
    } = props.contact;

    const form = {
      user : mapFormFields(user, formFields.user.required, formFields.user.optional),
      profile : mapFormFields(profile, formFields.profile.required, formFields.profile.optional),
      company : mapFormFields(company, formFields.company.required, formFields.company.optional)
    };

    // phone number hacks for now since this seems to be an old style form not using the actual schema
    // TODO: change form to use schema instead of mapFormFields
    set(form.user.phoneNumber1, 'isLength', {options: {min: 10, max: 10}, message: 'Must be 10 digits' });
    set(form.user.phoneNumber2, 'isLength', {options: {min: 10, max: 10}, message: 'Must be 10 digits' });
    set(form.user.email, 'isEmail', { message: 'Must be a valid email.' });

    this.state = form;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.contact) {
      const {
        user,
        profile,
        company
      } = nextProps.contact;
      const form = {
        user : mapFormFields(user, formFields.user.required, formFields.user.optional),
        profile : mapFormFields(profile, formFields.profile.required, formFields.profile.optional),
        company : mapFormFields(company, formFields.company.required, formFields.profile.optional)
      };

      // phone number hacks for now since this seems to be an old style form not using the actual schema
      set(form.user.phoneNumber1, 'isLength', {options: {min: 10, max: 10}, message: 'Must be 10 digits' });
      set(form.user.phoneNumber2, 'isLength', {options: {min: 10, max: 10}, message: 'Must be 10 digits' });
      set(form.user.email, 'isEmail', { message: 'Must be a valid email.' });
      this.setState(form);
    }
  }

  updateField = (event, model, prop, value) => {
    const currentState = merge({}, this.state);
    const newValue = value || event.target.value;
    const isDirty = get(currentState, `${model}.${prop}.defaultValue`) === newValue;
    const newState = set(currentState, `${model}.${prop}.value`,  newValue);
    if(isDirty) {
      this.setState(newState);
      return;
    }

    set(newState, `${model}.${prop}.errors`, validateFormField(prop, newState[model]));
    this.setState(newState);
  }

  validateForm(form, fields) {
    forEach(form, (prop, key) => {
      if (fields.required.includes(key)) {
        set(form, `${key}.errors`,  validateFormField(key, form));
      }
    });
  }

  saveContact = () => {


    const {company, profile, user} = merge({}, this.state);

    this.validateForm(company, formFields.company);
    this.validateForm(profile, formFields.profile);
    this.validateForm(user, formFields.user);

    const hasErrors = fieldsHasErrors(company) || fieldsHasErrors(profile) || fieldsHasErrors(user);

    if (hasErrors) {
      return this.setState({company, profile, user});
    }

    const newContact = reduce(this.state, (updateObj, model, key) =>
      set(updateObj, key,
          reduce(model,
            (obj, prop, name) => !isNil(get(prop, 'value')) ? set(obj, name, get(prop, 'value')) : obj,
            { id: this.props.contact[key].id }
          )
      ), {});

    this.props.dispatch(contactApi.updateContact(newContact, (err, data) => {
      if (err) {
        const customError = _.get(err, 'body.data.items[0]');
        if(_.get(customError, 'errorCode') === 'DUPLICATE_EMAIL') {
          const currentState = merge({}, this.state);
          const newState = set(currentState, 'user.email.errors[0]', customError.message);
          this.setState(newState);
        }

        return console.err(err);
      }

      this.props.dispatch(contactStore.updateContactInContactWorksheet(data));
      if (this.props.onClose) {
        this.props.onClose();
      }

      this.props.dispatch(ui.showSnackBar());
    }));
  }

  render() {

    const saveEnabled = reduce(this.state, (enabled, model) =>
      enabled || reduce(model, (enable, prop) =>
        enable || !isNil(prop.value) && (!prop.errors || !prop.errors.length), false)
    , false);

    const hasEditRights = (this.props.currentUser.roles.includes('Admin') || this.props.currentUser.id === get(this.props.contact, 'profile.createdBy', 0));

    return (
      <div className='edit-contact-container'>
        <EditContactDetailsForm
          contact={this.state}
          clientAdvisors={this.props.clientAdvisors}
          timezoneList={this.props.timezoneList}
          stateList={this.props.stateList}
          contactPhoneTypes={this.props.contactPhoneTypes}
          isDirty={saveEnabled}
          updateField={this.updateField}
          saveContact={this.saveContact}
          onClose={this.props.onClose}
          tasks={this.props.contact.profile.tasks}
          hasEditRights={hasEditRights}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Worksheet/Header/EditDetails/index.js